import { toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30e55782")

_pushScopeId("data-v-30e55782")
const _hoisted_1 = { style: {"font-weight":"700","font-size":"16px"} }
const _hoisted_2 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_3 = {
  class: "row",
  style: {"flex-direction":"column"}
}
const _hoisted_4 = { class: "col-12 col-md-6" }
const _hoisted_5 = { class: "row selling-settings-item" }
const _hoisted_6 = { class: "col-10 col-md-9 selling-settings-item-data" }
const _hoisted_7 = { class: "selling-settings-item-name" }
const _hoisted_8 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_9 = { class: "col-12 col-md-6" }
const _hoisted_10 = { class: "row selling-settings-item" }
const _hoisted_11 = { class: "col-10 col-md-9 selling-settings-item-data" }
const _hoisted_12 = { class: "selling-settings-item-name" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_14 = { class: "col-12 col-md-6" }
const _hoisted_15 = { class: "row selling-settings-item selling-settings-item-center" }
const _hoisted_16 = { class: "col-10 col-md-9 selling-settings-item-data" }
const _hoisted_17 = { class: "selling-settings-item-name" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_19 = { class: "col-12 col-md-6" }
const _hoisted_20 = { class: "row selling-settings-item" }
const _hoisted_21 = { class: "col-10 col-md-9 selling-settings-item-data" }
const _hoisted_22 = { class: "selling-settings-item-name" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_24 = { class: "col-12 col-md-6" }
const _hoisted_25 = { class: "row selling-settings-item" }
const _hoisted_26 = { class: "col-10 col-md-9 selling-settings-item-data" }
const _hoisted_27 = { class: "selling-settings-item-name" }
const _hoisted_28 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_29 = { class: "col-12 col-md-6" }
const _hoisted_30 = { class: "row selling-settings-item" }
const _hoisted_31 = { class: "col-10 col-md-9 selling-settings-item-data" }
const _hoisted_32 = { class: "selling-settings-item-name" }
const _hoisted_33 = /*#__PURE__*/_createVNode("i", {
  style: {"cursor":"help"},
  class: "icon-f icon-question fs-20"
}, null, -1)
const _hoisted_34 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_35 = { class: "row selling-settings-item" }
const _hoisted_36 = { class: "col-12 printing-type-title" }
const _hoisted_37 = { class: "col-12" }
const _hoisted_38 = {
  key: 1,
  class: "row",
  style: {"flex-direction":"column"}
}
const _hoisted_39 = {
  key: 0,
  class: "col-6 col-md-4 pt-3"
}
const _hoisted_40 = {
  key: 0,
  style: {"font-size":"14px"}
}
const _hoisted_41 = {
  key: 1,
  class: "col-6 col-md-4 pt-3"
}
const _hoisted_42 = {
  key: 2,
  class: "col-6 col-md-4 pt-3"
}
const _hoisted_43 = {
  key: 3,
  class: "col-6 col-md-4 pt-3"
}
const _hoisted_44 = {
  key: 4,
  class: "col-6 col-md-4 pt-3"
}
const _hoisted_45 = {
  key: 5,
  class: "col-6 col-md-4 pt-3"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", {
    class: ["selling-settings-page col-12", { editMode: _ctx.editMode }]
  }, [
    _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('product.selling-settings.title')), 1),
    (_ctx.editMode)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('product.selling-settings.cashier')), 1),
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle2 toggle",
                    checked: _ctx.useCashier,
                    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingCashier && _ctx.ChangeSellingSettingCashier(...args)), ["stop"]))
                  }, null, 8, ["checked"])
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.cashier.info')
                }, [
                  _hoisted_8
                ], 8, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('product.selling-settings.locals')), 1),
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle2 toggle",
                    checked: _ctx.useLocals,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingLocals && _ctx.ChangeSellingSettingLocals(...args)), ["stop"]))
                  }, null, 8, ["checked"])
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.locals.info')
                }, [
                  _hoisted_13
                ], 8, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('product.selling-settings.groups')), 1),
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle2 toggle",
                    checked: _ctx.useGroups,
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingGroups && _ctx.ChangeSellingSettingGroups(...args)), ["stop"]))
                  }, null, 8, ["checked"])
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.groups.info')
                }, [
                  _hoisted_18
                ], 8, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('product.selling-settings.b2c-channels')), 1),
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle2 toggle",
                    checked: _ctx.useB2cChannels,
                    onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingB2cChannels && _ctx.ChangeSellingSettingB2cChannels(...args)), ["stop"]))
                  }, null, 8, ["checked"])
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.b2cchannels.info')
                }, [
                  _hoisted_23
                ], 8, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode("div", _hoisted_26, [
                  _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t('product.selling-settings.index')), 1),
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle2 toggle",
                    checked: _ctx.useIndex,
                    onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingIndex && _ctx.ChangeSellingSettingIndex(...args)), ["stop"]))
                  }, null, 8, ["checked"])
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.index.info')
                }, [
                  _hoisted_28
                ], 8, ["title"])
              ])
            ]),
            _createVNode("div", _hoisted_29, [
              _createVNode("div", _hoisted_30, [
                _createVNode("div", _hoisted_31, [
                  _createVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('product.selling-settings.direct-channels')), 1),
                  _createVNode("input", {
                    type: "checkbox",
                    class: "toggle2 toggle",
                    checked: _ctx.useDirectChannels,
                    onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.ChangeSellingSettingDirectChannels && _ctx.ChangeSellingSettingDirectChannels(...args)), ["stop"]))
                  }, null, 8, ["checked"])
                ]),
                _createVNode("span", {
                  title: _ctx.$t('selling-settings.direct-channels.info')
                }, [
                  _hoisted_33
                ], 8, ["title"])
              ])
            ]),
            (_ctx.useCashier)
              ? (_openBlock(), _createBlock("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('ticket-printing-type.lable')), 1),
                    _createVNode("div", _hoisted_37, [
                      _createVNode(_component_Multiselect, {
                        label: "name",
                        modelValue: _ctx.printingType,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.printingType = $event)),
                        options: _ctx.printingTypes,
                        canDeselect: true,
                        valueProp: "id",
                        searchable: false,
                        onChange: _ctx.ChangeSellingSettingPrintingType
                      }, null, 8, ["modelValue", "options", "onChange"]),
                      (_ctx.printingType)
                        ? (_openBlock(), _createBlock("span", {
                            key: 0,
                            class: "icon-f icon-delete-cross fs-14 deletePrintingType",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.ChangeSellingSettingPrintingType(null)))
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_38, [
          (_ctx.useCashier)
            ? (_openBlock(), _createBlock("div", _hoisted_39, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.cashier')), 1),
                (_ctx.printingType)
                  ? (_openBlock(), _createBlock("span", _hoisted_40, " - " + _toDisplayString(_ctx.$t('printing-type.' + _ctx.PrintingTypeEnum[_ctx.printingType])), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useLocals)
            ? (_openBlock(), _createBlock("div", _hoisted_41, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.locals')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useGroups)
            ? (_openBlock(), _createBlock("div", _hoisted_42, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.groups')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useB2cChannels)
            ? (_openBlock(), _createBlock("div", _hoisted_43, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.b2c-channels')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useIndex)
            ? (_openBlock(), _createBlock("div", _hoisted_44, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.index')), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.useDirectChannels)
            ? (_openBlock(), _createBlock("div", _hoisted_45, [
                _createVNode("span", null, _toDisplayString(_ctx.$t('product.selling-settings.direct-channels')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 2))
})